export default "https://assets.egbcdn.net/assets/packs/_/images/user-promotions-promo/x2-casino-ee854bb449b2aaae61d5bc4de5edcc01.png";